var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FDEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15L26.6327 27.1425C26.5579 28.1891 25.687 29 24.6378 29H16.3622C15.313 29 14.4421 28.1891 14.3673 27.1425L13.5 15M18.5 19V25M22.5 19V25M23.5 15V12C23.5 11.4477 23.0523 11 22.5 11H18.5C17.9477 11 17.5 11.4477 17.5 12V15M12.5 15H28.5",
    stroke: "#EA5A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.84ffa93cfd06364f2abf598ba8728d5f.svg";
export { ForwardRef as ReactComponent };